import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft, ShieldCheck, Lock, EyeOff, Trash2, HandHeart } from "lucide-react";
import NavBar from "@/NavBar";
import Footer from "@/Footer";

const points = [
  { icon: Lock, title: "Your data stays yours", body: "The things you put into our apps belong to you. We store them so the app works for you — not to trade or sell." },
  { icon: EyeOff, title: "We don't sell your information", body: "Plain and simple. We don't sell your personal information to advertisers or data brokers. Ever." },
  { icon: ShieldCheck, title: "Protected by strong security", body: "We use modern encryption to keep your information safe while it travels and while it's stored." },
  { icon: Trash2, title: "Leave anytime", body: "You can ask us to delete your account and data whenever you like, right from our Delete Account page." },
  { icon: HandHeart, title: "Built with care", body: "We build these apps for our own family and yours. We treat your trust the way we'd want ours treated." },
];

export const Security = () => (
  <div className="hi-bg hi-grain min-h-screen">
    <NavBar />
    <div className="relative z-[2] max-w-3xl mx-auto px-5 py-10 md:py-14">
      <Link to="/" data-testid="security-back" className="hi-cta inline-flex items-center gap-2 rounded-full px-4 py-2 text-sm font-semibold hi-body bg-white/5 border border-white/10 text-white/80 hover:bg-white/10">
        <ArrowLeft size={16} strokeWidth={2.5} /> Back to Suite
      </Link>

      <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }} className="mt-8">
        <div className="flex items-center gap-3">
          <span className="grid place-items-center w-11 h-11 rounded-xl bg-[#3b9bff]/15 text-[#3b9bff] border border-[#3b9bff]/30"><ShieldCheck size={20} /></span>
          <h1 className="hi-serif text-3xl md:text-4xl text-[#f3ead4]">Privacy & Security</h1>
        </div>
        <p className="hi-body text-white/75 mt-3 max-w-2xl">
          Here's our approach to privacy and security, in plain language — no jargon required.
        </p>

        <div className="grid gap-4 mt-8" data-testid="security-points">
          {points.map((p) => (
            <div key={p.title} className="hi-card p-6 flex items-start gap-4">
              <span className="grid place-items-center w-10 h-10 rounded-xl bg-white/8 text-[#3b9bff] shrink-0"><p.icon size={20} /></span>
              <div>
                <h3 className="hi-serif text-lg text-[#f3ead4]">{p.title}</h3>
                <p className="hi-body text-sm text-white/70 mt-1.5 leading-relaxed">{p.body}</p>
              </div>
            </div>
          ))}
        </div>

        <p className="hi-body text-sm text-white/65 mt-8">
          For the full details, read our <Link to="/privacy" className="text-[#3b9bff] underline">Privacy Policy</Link> and{" "}
          <Link to="/terms" className="text-[#3b9bff] underline">Terms & Conditions</Link>.
        </p>
      </motion.div>
    </div>
    <div className="relative z-[2]"><Footer /></div>
  </div>
);

export default Security;
